export const corePopularPrograms = 'virtual/topsearch';
export const coreAutoSuggest = 'virtual/autosuggest';
export const coreSearchResults = 'virtual/appsearch';
